module.exports = function (unsubscribeEdmService, settingsService, $state, $sce, $log) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.messages = {};
            scope.isInit = false;
            scope.unsubscribeData = {};
            scope.preferences = {};
            scope.showEmail = false;
            scope.unsubscribeFromAll = false;
            const buildRequestRequest = (subscribeToLatest, subscribeToFavourites) => {
               return {
                   OptInEmail: subscribeToLatest,
                   OptInSms: subscribeToFavourites,
                   OptInMms: subscribeToFavourites,
                   OptInFavouritesSms: subscribeToFavourites,
                   Checksum: scope.unsubscribeData.Checksum,
                   ShopperId: scope.unsubscribeData.ShopperId,
                   Email: scope.unsubscribeData.Email
               };
           };

            function redirectErrorPage() {
               $state.go('shop.404error');
            }

            function getShopperAndChecksum() {
               try {
                  scope.unsubscribeData.ShopperId = parseInt($state.params.shopperID) || parseInt($state.params.s);
                  scope.unsubscribeData.Checksum = parseInt($state.params.checksum) || parseInt($state.params.c);
               } catch (e) {
                  $log.log('ShopperID or Checksum are not on the correct format.');
                  redirectErrorPage();
               }
            }

            function _init() {
                getShopperAndChecksum();
                let documentID = parseInt($state.params.documentID) || parseInt($state.params.d);
                if (!documentID) {
                     documentID = null;
                }
                unsubscribeEdmService.unsubscribeEDM(scope.unsubscribeData.ShopperId, scope.unsubscribeData.Checksum, documentID).then(function (response) {
                    if (response.Success) {
                      scope.unsubscribeData = response;
                      scope.preferences.subscribeToLatest = scope.unsubscribeData.OptInEmail;
                      scope.preferences.subscribeToFavourites = (scope.unsubscribeData.OptInFavouritesSms &&
                                                                  scope.unsubscribeData.OptInMms &&
                                                                  scope.unsubscribeData.OptInSms);
                     if (parseInt($state.params.shopperID) && parseInt($state.params.checksum)) {
                        scope.showEmail = true;
                     }
                      getShopperAndChecksum();

                      scope.isInit = true;
                   } else {
                      redirectErrorPage();
                   }
                });
            }

            scope.$watch('preferences.subscribeToLatest', (newValue, oldValue) => {
               if (oldValue === undefined) return;
               if (newValue !== oldValue) {
                  scope.preferences.subscribeToLatest = newValue;
                  const requestData = buildRequestRequest(scope.preferences.subscribeToLatest, scope.preferences.subscribeToFavourites);
                  scope.unsubscribeEDMConfirmation(requestData);
                }
             });

             scope.$watch('preferences.subscribeToFavourites', (newValue, oldValue) => {
               if (oldValue === undefined) return;
               if (newValue !== oldValue) {
                  scope.preferences.subscribeToFavourites = newValue;
                  const requestData = buildRequestRequest(scope.preferences.subscribeToLatest, scope.preferences.subscribeToFavourites);
                  scope.unsubscribeEDMConfirmation(requestData);
                }
             });

            scope.unsubscribeAll = function () {
               scope.preferences.subscribeToLatest = false;
               scope.preferences.subscribeToFavourites = false;
               const requestData = buildRequestRequest(scope.preferences.subscribeToLatest, scope.preferences.subscribeToFavourites);
               scope.unsubscribeEDMConfirmation(requestData);
               scope.unsubscribeFromAll = true;
            };

            scope.unsubscribeEDMConfirmation = (requestData) => {
               if (!scope.unsubscribeFromAll) {
                  unsubscribeEdmService.unsubscribeEDMConfirmation(requestData).then(function (response) {
                  scope.unsubscribeFromAll = false;
                     if (response.ShouldRedirectToHomePage) {
                        $state.go('home');
                     }
                  });
               }
            };
            _init();
        },
        template: require('./unsubscribe-edm-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/unsubscribeedm/unsubscribe-edm-directive.js
 **/